import { track } from '@amplitude/analytics-browser';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { IDeviceShadowRecord } from 'src/app/shared/services/device-shadow/device-shadow.service';
import { DeviceVersion } from 'src/app/shared/services/versions/versions.service';
import { SearchParameters } from '../device-monitoring-search/device-monitoring-search.component';
import { ITimelineData } from '../device-timeline/timeline.component';
import {
  DeviceEvent,
  IDevicePhoto,
  MonitoringService,
} from '../services/monitoring.service';

@Component({
  selector: 'dcc-device-monitoring',
  templateUrl: './devicemonitoring.component.html',
  styleUrls: ['./devicemonitoring.component.scss'],
})
export class DevicemonitoringComponent implements OnInit {
  startDate: Date | undefined;
  endDate: Date | undefined;
  serialNumbers: string[] = [];
  deviceData: Map<string, IDeviceMonitoringData>;

  loading = false;
  error = false;

  constructor(
    private monitoringService: MonitoringService,
    protected changes: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    track('Control Center Device Monitoring  page Loaded');
  }

  async clickSearched(params: SearchParameters) {
    this.loading = true;
    this.startDate = new Date(params.start);
    this.endDate = new Date(params.end);
    this.serialNumbers = params.serialNumbers.map(sn => sn.toUpperCase());
    this.deviceData = await this.loadMonitoringData();
    this.changes.detectChanges();
  }

  private async loadMonitoringData(): Promise<
    Map<string, IDeviceMonitoringData>
  > {
    this.error = false;
    this.loading = true;
    this.changes.detectChanges();

    try {
      const data = await this.monitoringService.getMonitoringData(
        this.serialNumbers,
        this.startDate,
        this.endDate,
      );
      return data;
    } catch (error) {
      console.error(error);
      this.error = true;
    } finally {
      this.loading = false;
    }

    return new Map<string, IDeviceMonitoringData>();
  }
}

// temporary type used to tie serialNumbers to data arrays during processing. Not used outside this component. Essentially a type-safe tuple.
export interface IDeviceMonitoringData {
  serialNumber: string;
  timelineData?: ITimelineData[];
  metadata?: IDeviceShadowRecord;
  geotabMetadata?: IDeviceShadowRecord;
  deviceVersion?: DeviceVersion;
  photos?: IDevicePhoto[];
  deviceEvent?: DeviceEvent[];
  deviceEncryptionKey?: string;
}
